// Chat Widget Constants

export const STARTERS = [
  'How do I add a property to PropAtlas?',
  'How do I manage the property timeline and documents?',
  'How does the EOI marketplace work?',
  'What is LVR and how does it affect borrowing capacity?',
  'Can my SMSF buy a property?',
  'How do I track a renovation project?',
  'What is LMI and when is it required?',
  'How do I share property information with others?',
];

export const SOURCE_COLORS = {
  'ATO.gov.au': { bg: '#fff3e0', color: '#e65100' },
  'APRA.gov.au': { bg: '#e8f5e9', color: '#1b5e20' },
  'RBA.gov.au': { bg: '#e3f2fd', color: '#0d47a1' },
  'ASIC.gov.au': { bg: '#f3e5f5', color: '#4a148c' },
  'PropAtlas Guide': { bg: '#e8f5e9', color: '#1f3a2e' },
  'ASIC MoneySmart': { bg: '#f3e5f5', color: '#4a148c' },
};

// Layout constants
export const FAB_SIZE = 56;
export const FAB_POSITION = 24;
export const FAB_Z_INDEX = 200;
export const MOBILE_HEIGHT_VH = 88;
export const MOBILE_BREAKPOINT = 480;

// API request configuration
export const API_TIMEOUT_MS = 30000;
export const MAX_MESSAGE_LENGTH = 2000;
export const CHAT_HISTORY_WINDOW = 50;

// Retry configuration
export const RETRY_CONFIG = {
  maxAttempts: 3,
  initialDelayMs: 1000,
  maxDelayMs: 10000,
  backoffMultiplier: 2,
};

// Error messages
export const ERROR_MESSAGES = {
  NETWORK: 'Network error. Please check your connection and try again.',
  TIMEOUT: 'Request timed out. Please try again.',
  RATE_LIMIT: 'Too many requests. Please wait a moment before trying again.',
  VALIDATION: 'Your message is invalid. Please check and try again.',
  SERVER: 'Server error. Please try again later.',
  UNKNOWN: 'Something went wrong. Please try again.',
};

// Error type classification
export const ERROR_TYPES = {
  NETWORK: 'network',
  TIMEOUT: 'timeout',
  RATE_LIMIT: 'rate_limit',
  VALIDATION: 'validation',
  SERVER: 'server',
  UNKNOWN: 'unknown',
};

// Feedback options
export const FEEDBACK_OPTIONS = [
  { label: 'Helpful 👍', value: 'helpful' },
  { label: 'Not helpful 👎', value: 'not_helpful' },
];
